import { useQuery } from 'react-query';
import User from '../models/User';

function useChatAdmin() {
    return useQuery<User>('users/getchatadministrator', { staleTime: Infinity });
}

export default useChatAdmin;
